module.exports = __webpack_public_path__ + "img/gratitude-journal_B095M7WV3D.3d52188a.jpg";